/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-11-14 09:25:32
 */
 
import Api from "src/util/api";
import {PageDo, Result, ResultPageDo} from "src/types/base";
export declare namespace DataViewDOI {

	export interface RowDataI {
        device_name: string,
        DataTime: string
        MN: string
        [str: string]: any
	}

	export interface QueryRowDataParamsI  {
        cn?: string
        type?: number
        device_name?: string
    }
    
    export interface QueryDetailParamsI extends PageDo {
        mn?: string
        start_time?: string
        end_time?: string
        cn?: string
    }

    export interface Limits {
      alarm_ceiling: number,
      alarm_floor: number
      key: string
    }

	export interface QueryDetailRowI {

	}

	export interface OperateParamsI {
		
	}

}
export default class DataViewApi {
	/**
	 * 查询列表
	 * @param {DataViewDOI.QueryRowDataParamsI} params
	 * @returns {Promise<ResultPageDo<PeopleManageRowI[]>>}
	 */
	static async searchList(params: DataViewDOI.QueryRowDataParamsI):Promise<ResultPageDo<DataViewDOI.RowDataI[], { key: string; name: string; unit: string }[]>> {
		return Api.post('/monitor/cn_by_data/query', {
            device_name: '',
            ...params
        })
    }
    
    static async searchDataType():Promise<Result<{data_name: string, cn: string}[]>> {
		return Api.post('/monitor/all_data_type/query')
    }
    
    static async searchDetailList(params: DataViewDOI.QueryDetailParamsI):Promise<ResultPageDo<{data_name: string, cn: string}[], { key: string; name: string; unit: string }[]>> {
		return Api.post('/monitor/cn_by/all_data/query',params)
    }
    
    static async searchDataTypeRelation(product_id: number, type: number = -2):Promise<Result<{data_name: string,data_type_id:number,type: number,cn: string}[]>> {
		return Api.post('/monitor/point/product/data_type/data/by/type',{product_id,type})
    }
    
    static async getRealTimeData(mn: string, cn: string = '2011'):Promise<ResultPageDo<{DateTime: string}[], {key: string, name: string, unit: string}[]>> {
		return Api.post('/monitor/point/realtime/last/data/get',{mn,cn})
    }
    
    static async exportAll():Promise<Result<{download_url: string}>> {
		return Api.post('/monitor/data_export/all_site')
    }
    
    static async exportSingleStation():Promise<Result<{download_url: string}>> {
		return Api.post('/monitor/data_export/single_site')
	}
  static async exportDatatimeSingleStation(mn: string, cn: string, start_time: any, end_time:any):Promise<Result<{download_url: string}>> {
		return Api.post('/monitor/datatime/data_export/single_site',{mn,cn,start_time,end_time})
	}

  static async getLimits(mn: string):Promise<Result<DataViewDOI.Limits[]>> {
		return Api.post('/monitor/devices/mn/limits',{mn})
  }
}